const data = [
  {
    id: 1,
    image: "https://img.icons8.com/external-outline-juicy-fish/60/000000/external-freelancing-side-hustles-outline-outline-juicy-fish.png",
    title: "Freelancing",
    desc: "Freelancing has allowed me to learn more about myself than any other career I’ve had and it has allowed me to live my days as I see fit.",
  },
  {
    id: 2,
    image: "https://img.icons8.com/pastel-glyph/64/000000/page-not-found--v2.png",
    title: "Web Development",
    desc: " Actually in all seriousness, what I enjoy most is building my own projects and seeing people use them once they're done.",
  },
  {
    id: 3,
    image: "https://img.icons8.com/external-xnimrodx-lineal-xnimrodx/64/000000/external-coding-ui-and-ux-xnimrodx-lineal-xnimrodx.png ",
    title: "Software Development",
    desc: "I enjoy the process of coding, Googling whatever I need to, and then getting to a solution. That feeling, that gratification of solving a bug, is unmatched.",
  },
]
export default data
